import { useCurrencyFormat } from "~/hooks/use-currency-format";
import type { Currency } from "~/service/order/schema";

export function AmountDisplay({
  label,
  amount,
  currency,
}: {
  label: string;
  amount: string;
  currency: Currency;
}) {
  const currencyFormatter = useCurrencyFormat(currency.code);

  return (
    <div className="flex flex-col gap-1">
      <span className="text-base font-semibold text-neutral-900">{label}</span>
      <div className="flex items-center gap-3">
        {currency.imageUrl && (
          <img
            className="size-8 rounded-full bg-neutral-200"
            src={currency.imageUrl}
            alt={`Icon for ${currency.name}`}
          />
        )}
        <h2 className="text-4xl font-extrabold">
          {currencyFormatter.format(Number.parseFloat(amount))}
        </h2>
      </div>
    </div>
  );
}
